import { createAsyncThunk } from "@reduxjs/toolkit";

import { axiosInstance as axios } from "../../../../api/axiosInstance";
import { showSnackbar } from "../../../reducers/snackbar/snackbarSlice";

export const getUserTypes = createAsyncThunk(
  "getUserTypes",
  (_, { dispatch, rejectWithValue }) => {
    return axios.get("/api/v1/usertypes")
      .then(resp => {
        return resp.data;
      })
      .catch(() => {
        const errorMessage = "There was an error fetching user types";

        dispatch(showSnackbar({
          message: errorMessage,
          variant: "error"
        }));

        return rejectWithValue(errorMessage);
      });
  }
);
